// REFACTORED: 2026-02-02
// FROM src/components/project/Projects.tsx

// ============================================================================
// PROJECT CONSTANTS - Constants for project-related functionality
// ============================================================================

/**
 * Quarters for opportunity filtering
 */
export const QUARTERS = ["Q1", "Q2", "Q3", "Q4"];

/**
 * Color scheme mapping for different status types
 */
export const STATUS_COLORS = {
  primary: 'primary',
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info',
  gray: 'gray',
} as const;

// REFACTORED: 2026-02-02
// FROM src/components/project/ProjectAnalytics.tsx

/**
 * Project statuses for analytics
 */
export const PROJECT_STATUSES = ["In Progress", "Yet to Start", "Completed", "On Hold"];

/**
 * RAG statuses for analytics
 */
export const RAG_STATUSES = ["Green", "Amber", "Red"];

